var exports = {
  "kL": "x9997bc76--ca4787--container",
  "Qs": "x9997bc76--ca4787--content",
  "DD": "x9997bc76--ca4787--title",
};

module.exports = exports;
